import { v4 as uuid } from "uuid";
import { IConclusionService, IConclusionServiceData } from "./ITypes.ts";
import { ErrorSessionNotFound } from "./Errors.ts";

export default class ConclusionService implements IConclusionService {
    constructor(_baseUrl: string) {
        this.baseUrl = _baseUrl;
    }
    private baseUrl: string | undefined = undefined;

    public session_id: string = "";
    private intervalID: ReturnType<typeof setInterval> | undefined;

    public async openConstructor(reportData: IConclusionServiceData) {
        this.session_id = uuid();
        const dataStr = window.btoa(JSON.stringify(reportData));

        let url = new URL(this.baseUrl + "api/ConclusionConstructor/Start");
        url.searchParams.append("sessionId", this.session_id);
        url.searchParams.append("base64Data", dataStr);

        await fetch(url, {
            method: "GET"
        });

        return this.session_id;
    }
    public async StartWaitAnswer() {
        return new Promise<string>((resolve, reject) => {
            // Clear previous interval
            clearInterval(this.intervalID as NodeJS.Timeout);
            let waiting = false;
            this.intervalID = setInterval(async () => {
                try {
                    if (waiting) {
                        return;
                    }
                    waiting = true;
                    const res = await this.checkConclusion();
                    if (res) {
                        this.StopWaitAnswer();
                        resolve(res);
                    }
                } catch (err) {
                    this.StopWaitAnswer();
                    reject(err);
                } finally {
                    waiting = false;
                }
            }, 1000);
        });
    }

    public StopWaitAnswer() {
        clearInterval(this.intervalID as NodeJS.Timeout);
    }

    private async checkConclusion() {
        let url = new URL(this.baseUrl + "api/ConclusionConstructor/CheckConclusion");
        url.searchParams.append("sessionId", this.session_id);

        const res = await fetch(url);
        // Ok
        if (res.ok) {
            return await res.text();
        }
        //this.StopWaitAnswer();

        // Wrong id, session is not found
        if (res.status === 409) {
            throw new ErrorSessionNotFound();
        }

        //throw new Error();
    }
}
